import script from "./TableSettingsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TableSettingsDialog.vue?vue&type=script&setup=true&lang=js"

import "./TableSettingsDialog.vue?vue&type=style&index=0&id=34ccafe9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ccafe9"]])

export default __exports__